
// Lastly, we import everything and export a single object

import enUsTranslations from './en-us'
import deDETranslations from './de-de'

export default {
  'en-US': enUsTranslations,
  'de-DE': deDETranslations
}